import { useEffect } from "react";
import { useSiteSettings } from "@/lib/siteSettings";

/**
 * The Karijeeva logo, set in Admin > Settings. `on` is the background it sits
 * on; each variant falls back to the other, then to the text wordmark.
 */
export default function Logo({ on = "dark", className = "", textClassName = "" }) {
  const s = useSiteSettings();
  const src = on === "light" ? s.logo_on_light_url || s.logo_url : s.logo_url || s.logo_on_light_url;
  if (!src) return <span className={textClassName}>Karijeeva</span>;
  return <img src={src} alt="Karijeeva" className={className} decoding="async" />;
}

/** Swaps the browser tab icon when a favicon is set in Admin > Settings. */
export function useSettingsFavicon() {
  const { favicon_url } = useSiteSettings();
  useEffect(() => {
    if (!favicon_url) return;
    document.querySelectorAll("link[rel~='icon']").forEach((l) => { l.href = favicon_url; });
  }, [favicon_url]);
}
